// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18zrze3t{padding-inline:var(--ds-space-0,0)}\n._1rjcze3t{padding-block:var(--ds-space-0,0)}\n._1e0c1bgi{display:contents}", ""]);
// Exports
module.exports = exports;
